module.exports = __webpack_public_path__ + "static/media/wifi-level-3-mobile.aede0826.svg";